module.exports = __webpack_public_path__ + "static/media/Locations & Payroll Reference.8a45c4af.csv";